import {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import {defineStreamComponentRegistration} from '@Components/ai-chat-window/lib/stream-component-registration';
import {isOptionalString, parseEachOrNull} from '@Components/ai-chat-window/lib/stream-component-prop-guards';
import {parseEntityCardProps} from '@Components/ai-chat-window/components/entity-card/entity-card.library';
import type {EntityCardGroupProps} from './entity-card-group.types';
import {EntityCardGroup} from './entity-card-group';

export const entityCardGroupRegistration = defineStreamComponentRegistration(
  StreamComponentType.ENTITY_CARD_GROUP,
  EntityCardGroup,
  (props: Record<string, unknown>): EntityCardGroupProps | null => {
    if (!isOptionalString(props.title) || !Array.isArray(props.cards) || props.cards.length === 0) {
      return null;
    }

    const cards = parseEachOrNull(props.cards, parseEntityCardProps);
    if (cards === null) {
      return null;
    }

    return {title: props.title, cards};
  }
);
